import React, { useState, useContext } from "react";
import { IconButton, Stack, Box, Tooltip } from "@mui/material";
import { useMutation } from "@apollo/client";
//Icons
import { MdDelete } from "react-icons/md";
import { BsEyeFill } from "react-icons/bs";
import { TbEdit } from "react-icons/tb";
import { BsPrinterFill } from "react-icons/bs";
import { IoMdPrint } from "react-icons/io";
import { FaRegEye } from "react-icons/fa";
import { FaRegClone } from "react-icons/fa";
//Srcs
import "../../Style/actionstyle.scss";
import UpdateClassItem from "./UpdateClassItem";
import ViewClassItem from "./ViewClassItem";
import Delete from "../Include/Delete";
import { DELETE_CLASS_ITEM } from "../../Schema/ClassItem";
import { AuthContext } from "../../Context/AuthContext";
import CloneClassItem from "./CloneClassItem";

export default function ClassItemAction({ editData, setRefetch }) {
  const [loading, setLoading] = useState(false);
  const { setAlert } = useContext(AuthContext);

  //Modal update
  const [openEdit, setOpenEdit] = useState(false);
  const handleOpenEdit = () => setOpenEdit(true);
  const handleCloseEdit = () => setOpenEdit(false);

  //Modal Clone
  const [openClone, setOpenClone] = useState(false);
  const handleOpenClone = () => setOpenClone(true);
  const handleCloseClone = () => setOpenClone(false);

  //Modal delete
  const [openDel, setOpenDel] = useState(false);
  const handleOpenDel = () => setOpenDel(true);
  const handleCloseDel = () => setOpenDel(false);

  //Modal delete
  const [openView, setOpenView] = useState(false);
  const handleOpenView = () => setOpenView(true);
  const handleCloseView = () => setOpenView(false);

  const [deleteClassItem] = useMutation(DELETE_CLASS_ITEM, {
    onCompleted: ({ deleteClassItem }) => {
      setLoading(false);
      if (deleteClassItem?.status === true) {
        setAlert(true, "success", deleteClassItem?.message);
        handleCloseDel();
        setRefetch();
      } else {
        setAlert(true, "error", deleteClassItem?.message);
      }
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const handleDelete = () => {
    setLoading(true);
    deleteClassItem({
      variables: {
        id: editData?._id,
      },
    });
  };

  return (
    <div>
      <Stack direction="row" justifyContent="right">

        <Tooltip title="ពិនិត្យ" placement="top">
          <IconButton onClick={handleOpenView}>
            <Box
              className="update-container"
              sx={{ border: "1px solid #4caf50 !important" }}
            >
              <FaRegEye style={{ fontSize: "18px", color: "#4caf50" }} />
            </Box>
          </IconButton>
        </Tooltip>

        <Tooltip title="កែប្រែ" placement="top">
          <IconButton onClick={handleOpenEdit}>
            <Box className="update-container">
              <TbEdit className="update-icon" />
            </Box>
          </IconButton>
        </Tooltip>

        <Tooltip title="ចម្លង" placement="top">
          <IconButton onClick={handleOpenClone}>
            <Box className="update-container">
              <FaRegClone className="update-icon" />
            </Box>
          </IconButton>
        </Tooltip>

        <Tooltip title="លុប" placement="top">
          <IconButton onClick={handleOpenDel}>
            <Box className="delete-container">
              <MdDelete className="delete-icon" />
            </Box>
          </IconButton>
        </Tooltip>

      </Stack>

      <UpdateClassItem
        handleClose={handleCloseEdit}
        setRefetch={setRefetch}
        editData={editData}
        open={openEdit}
      />
    
      <CloneClassItem
        handleClose={handleCloseClone}
        setRefetch={setRefetch}
        editData={editData}
        open={openClone}
      /> 

      <ViewClassItem
        open={openView}
        handleClose={handleCloseView}
        editData={editData}
      />

      <Delete
        open={openDel}
        handleClose={handleCloseDel}
        title={"សម្ភារៈក្នុងថ្នាក់"}
        loading={loading}
        handleDelete={handleDelete}
      />
    </div>
  );
}
